import { DefaultButton } from 'components/button/DefaultButton';
import { ValidatableLabel } from 'components/forms/ValidatableLabel';
import { LoginForm, StyledTextInput } from 'pages/Login/Login';
import { sdUserEmailRules, userEmailMaxLength } from 'pages/Login/shared';
import * as React from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';

export type EmailScreenProps = {
    register: UseFormRegister<LoginForm>;
    emailErrors: FieldError | undefined;
    onLogin: () => void;
    onSubmit: (event: React.FormEvent) => void;
    actionable: boolean;
};

export function EmailScreen({
    register,
    emailErrors,
    onLogin,
    onSubmit,
    actionable,
}: EmailScreenProps) {
    return (
        <form onSubmit={onSubmit} noValidate>
            <ValidatableLabel label="Email Address" className="mb-16" error={emailErrors}>
                <StyledTextInput
                    type="email"
                    placeholder="Enter your email address"
                    autofocus
                    invalid={emailErrors !== undefined}
                    maxLength={userEmailMaxLength}
                    {...register('email', sdUserEmailRules)}
                />
            </ValidatableLabel>
            <footer>
                <DefaultButton
                    type="button"
                    onClick={onLogin}
                    disabled={!actionable}
                    aria-label="Log In"
                >
                    Log In
                </DefaultButton>
            </footer>
        </form>
    );
}
